import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@material-ui/core/Button';

// eslint-disable-next-line
import style from './_style.css';

class Link extends Component {
    render() {
        return (
            <Button onClick={this.props.onClick} className={'root-link'}>
                <span className="c_bluish barlowsemicondensed_semibold_link hand">
                    <FormattedMessage id={this.props.id} />
                </span>
            </Button>
        );
    }
}

export default Link;



// WEBPACK FOOTER //
// ./src/components/buttons/Link.js